export const MaintenanceSynchroniser = 'MaintenanceSynchroniser';
export const CommandQueueRunner = 'CommandQueueRunner';
export const SyncIndicatorPreCloser = 'SyncIndicatorPreCloser';
export const SyncIndicatorOpener = 'SyncIndicatorOpener';
export const SyncIndicatorCloser = 'SyncIndicatorCloser';
export const SyncStarter = 'SyncStarter';
export const WebSyncStarter = 'WebSyncStarter';
export const TokenHandler = 'TokenHandler';
export const MaintenanceWatchStarter = 'MaintenanceWatchStarter';
export const ShutdownInfoListener = 'ShutdownInfoListener';
export const DatabaseCreator = 'DatabaseCreator';
export const IndexRebuilder = 'IndexRebuilder';
export const FtsIndexFinalizer = 'FtsIndexFinalizer';
export const ProduktlyInitializer = 'ProduktlyInitializer';
